export default __webpack_public_path__ + "static/media/breakout_rooms.551fea42.png";